/* jshint esversion: 6 */
/* jshint ignore:start */
import { useEffect, useState, useContext } from 'react';
import { MyContext } from '../../Context/MyProvider';
import axios from 'axios';
import secureLocalStorage from 'react-secure-storage';
import { useTranslation } from 'react-i18next';
import Payment from '../../PaymentGetaway/Payment';
import { showToast } from '../../showTost';
const Wallet = () => {

    const { t } = useTranslation();
    const { BaseUrl, paymentloading, paymentRes, setPaymentRes } = useContext(MyContext);

    const [loading, setLoading] = useState(true);
    const [mywallet, setMyWallet] = useState(0);
    const [income, setIncome] = useState(0);
    const [expense, setExpense] = useState(0);
    const [tarnsactionlist, setTransactionList] = useState([]);
    const [showPayBox, setShowPayBox] = useState(false);

    const Currency = secureLocalStorage.getItem("currency");

    useEffect(() => {
        const PaymentRes = sessionStorage.getItem("Paymentstatus");
        if (PaymentRes) {
            if (PaymentRes === "PaymentDone") {
                setPaymentRes("PaymentDone");
            } else {
                setPaymentRes("PaymentFail");
            }
        }
        handleFetchData();
    }, []);

    useEffect(() => {
        if (!paymentRes) return;
        if (paymentRes === "PaymentDone") {
            handleAddAmount();
        } else {
            showToast({ title: t("Payment faild !!"), id: "error" });
            setPaymentRes("");
            sessionStorage.removeItem("Paymentstatus");
            secureLocalStorage.removeItem("amount");
        }
    }, [paymentRes]);

    const handleFetchData = () => {
        const uid = secureLocalStorage.getItem("Userid");

        axios.post(`${BaseUrl}tcapi/s_wallet_report.php`, { uid })
            .then((res) => {
                setMyWallet(res.data.wallet);
                secureLocalStorage.setItem("wallet", res.data?.wallet);
                setIncome(res.data.credittotal);
                setExpense(res.data.debittotal);
                setTransactionList(res.data.Walletitem);
                setLoading(false);
            })
            .catch((error) => {
                console.error("s_wallet_report.php", error);
            });
    }

    const handleAddAmount = () => {
        const uid = secureLocalStorage.getItem("Userid");
        const wallet = secureLocalStorage.getItem("amount");

        axios.post(`${BaseUrl}tcapi/wallet_up.php`, { uid, wallet })
            .then((res) => {
                const Toastid = res.data.ResponseCode === "200" ? "success" : "error";
                showToast({ title: res.data.ResponseMsg, id: Toastid });
                handleFetchData();
                sessionStorage.removeItem("Paymentstatus");
                secureLocalStorage.removeItem("amount");
                setShowPayBox(false);
            })
            .catch((error) => {
                console.error("tcapi/wallet_up.php", error);
            })
    }

    return (
        <div className="wallet_page">
            {loading
                ? <div className="w-full h-[calc(100vh-85px)] bg-white z-[777] fixed flex items-center justify-center">
                    <div className="loader"></div>
                </div>
                :
                <div className="width_container">

                    <div className="section_1">
                        <div className="leading-5 max-_430_:text-center">
                            <h1 className="font-[500] text-[18px]">{t("Available Balance")}</h1>
                            <h1 className="font-bold text-[19px]">{Currency + mywallet}</h1>
                        </div>
                        <div className="flex items-center gap-[20px]">
                            <div className="income_box">
                                <div className="bg-green-600 text-white rounded-[8px] p-[3px]">
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M19.7071 14.707L12.708 21.7061C12.615 21.7991 12.5051 21.8721 12.3821 21.9231C12.2601 21.9741 12.13 22 12 22C11.87 22 11.74 21.9731 11.618 21.9231C11.495 21.8721 11.385 21.7991 11.292 21.7061L4.29301 14.707C3.90201 14.316 3.90201 13.684 4.29301 13.293C4.68401 12.902 5.31607 12.902 5.70707 13.293L11 18.5859V3C11 2.448 11.447 2 12 2C12.553 2 13 2.448 13 3V18.5859L18.293 13.293C18.684 12.902 19.3161 12.902 19.7071 13.293C20.0981 13.684 20.0981 14.316 19.7071 14.707Z" fill="currentColor " />
                                    </svg>
                                </div>
                                <div className="leading-5 text-center me-[3px]">
                                    <h1 className='text-gray-700'>{t("Income")}</h1>
                                    <span className="font-[600] text-[17px]">{Currency + income}</span>
                                </div>
                            </div>
                            <div className="expense_box">
                                <div className="bg-orange-600 text-white rounded-[8px] p-[3px]">
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M19.7071 10.7071C19.5121 10.9021 19.256 11.0001 19 11.0001C18.744 11.0001 18.488 10.9021 18.293 10.7071L13 5.41413V21.0001C13 21.5521 12.553 22.0001 12 22.0001C11.447 22.0001 11 21.5521 11 21.0001V5.41413L5.70707 10.7071C5.31607 11.0981 4.68401 11.0981 4.29301 10.7071C3.90201 10.3161 3.90201 9.68403 4.29301 9.29304L11.292 2.29401C11.385 2.20101 11.495 2.12797 11.618 2.07697C11.862 1.97597 12.1381 1.97597 12.3821 2.07697C12.5051 2.12797 12.615 2.20101 12.708 2.29401L19.7071 9.29304C20.0981 9.68403 20.0981 10.3161 19.7071 10.7071Z" fill="currentColor" />
                                    </svg>
                                </div>
                                <div className="leading-5 text-center me-[3px]">
                                    <h1 className='text-gray-700'>{t("Expense")}</h1>
                                    <span className="font-[600] text-[17px]">{Currency + expense}</span>
                                </div>
                            </div>
                            <button onClick={() => setShowPayBox(true)} className="border px-[15px] text-[15px] rounded-[10px] py-[8px] font-medium">Add Amount</button>
                        </div>
                    </div>

                    <div className="section_2">
                        <h1 className="font-[600] text-[18px]">{t("Transaction history")}</h1>

                        <div className="mt-[20px]">
                            {tarnsactionlist?.length >= 1
                                ? tarnsactionlist.map((item, index) => {
                                    return <div key={index} className="tarnsaction_box">
                                        <div className="flex items-center gap-[20px]">
                                            <div className={`${item.status === "Credit" ? "text-green-500 bg-green-200" : "text-[red] bg-red-200"} p-[10px] rounded-full`}>
                                                {item.status === "Credit"
                                                    ? <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M11.9402 2.20983L9.5302 7.81983H7.1202C6.7202 7.81983 6.3302 7.84983 5.9502 7.92983L6.9502 5.52983L6.9902 5.43983L7.0502 5.27983C7.0802 5.20983 7.1002 5.14983 7.1302 5.09983C8.2902 2.40983 9.5902 1.56983 11.9402 2.20983Z" fill="currentColor"></path>
                                                        <path d="M18.7301 8.09002L18.7101 8.08002C18.1101 7.91002 17.5001 7.82002 16.8801 7.82002H10.6201L12.8701 2.59002L12.9001 2.52002C13.0401 2.57002 13.1901 2.64002 13.3401 2.69002L15.5501 3.62002C16.7801 4.13002 17.6401 4.66002 18.1701 5.30002C18.2601 5.42002 18.3401 5.53002 18.4201 5.66002C18.5101 5.80002 18.5801 5.94002 18.6201 6.09002C18.6601 6.18002 18.6901 6.26002 18.7101 6.35002C18.8601 6.86002 18.8701 7.44002 18.7301 8.09002Z" fill="currentColor"></path>
                                                        <path d="M18.2902 9.51982C17.8402 9.38982 17.3702 9.31982 16.8802 9.31982H7.12023C6.44023 9.31982 5.80023 9.44982 5.20023 9.70982C3.46023 10.4598 2.24023 12.1898 2.24023 14.1998V16.1498C2.24023 16.3898 2.26023 16.6198 2.29023 16.8598C2.51023 20.0398 4.21023 21.7398 7.39023 21.9498C7.62023 21.9798 7.85023 21.9998 8.10023 21.9998H15.9002C19.6002 21.9998 21.5502 20.2398 21.7402 16.7398C21.7502 16.5498 21.7602 16.3498 21.7602 16.1498V14.1998C21.7602 11.9898 20.2902 10.1298 18.2902 9.51982ZM14.5002 16.1898H12.7502V17.9998C12.7502 18.4098 12.4102 18.7498 12.0002 18.7498C11.5902 18.7498 11.2502 18.4098 11.2502 17.9998V16.1898H9.50023C9.09023 16.1898 8.75023 15.8598 8.75023 15.4398C8.75023 15.0298 9.09023 14.6898 9.50023 14.6898H11.2502V12.9998C11.2502 12.5898 11.5902 12.2498 12.0002 12.2498C12.4102 12.2498 12.7502 12.5898 12.7502 12.9998V14.6898H14.5002C14.9102 14.6898 15.2502 15.0298 15.2502 15.4398C15.2502 15.8598 14.9102 16.1898 14.5002 16.1898Z" fill="currentColor"></path>
                                                    </svg>
                                                    : <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M11.9402 2.20983L9.5302 7.81983H7.1202C6.7202 7.81983 6.3302 7.84983 5.9502 7.92983L6.9502 5.52983L6.9902 5.43983L7.0502 5.27983C7.0802 5.20983 7.1002 5.14983 7.1302 5.09983C8.2902 2.40983 9.5902 1.56983 11.9402 2.20983Z" fill="currentColor"></path>
                                                        <path d="M18.7301 8.09002L18.7101 8.08002C18.1101 7.91002 17.5001 7.82002 16.8801 7.82002H10.6201L12.8701 2.59002L12.9001 2.52002C13.0401 2.57002 13.1901 2.64002 13.3401 2.69002L15.5501 3.62002C16.7801 4.13002 17.6401 4.66002 18.1701 5.30002C18.2601 5.42002 18.3401 5.53002 18.4201 5.66002C18.5101 5.80002 18.5801 5.94002 18.6201 6.09002C18.6601 6.18002 18.6901 6.26002 18.7101 6.35002C18.8601 6.86002 18.8701 7.44002 18.7301 8.09002Z" fill="currentColor"></path>
                                                        <path d="M18.2902 9.51982C17.8402 9.38982 17.3702 9.31982 16.8802 9.31982H7.12023C6.44023 9.31982 5.80023 9.44982 5.20023 9.70982C3.46023 10.4598 2.24023 12.1898 2.24023 14.1998V16.1498C2.24023 16.3898 2.26023 16.6198 2.29023 16.8598C2.51023 20.0398 4.21023 21.7398 7.39023 21.9498C7.62023 21.9798 7.85023 21.9998 8.10023 21.9998H15.9002C19.6002 21.9998 21.5502 20.2398 21.7402 16.7398C21.7502 16.5498 21.7602 16.3498 21.7602 16.1498V14.1998C21.7602 11.9898 20.2902 10.1298 18.2902 9.51982ZM14.5002 16.7498H9.50023C9.09023 16.7498 8.75023 16.4098 8.75023 15.9998C8.75023 15.5898 9.09023 15.2498 9.50023 15.2498H14.5002C14.9102 15.2498 15.2502 15.5898 15.2502 15.9998C15.2502 16.4098 14.9102 16.7498 14.5002 16.7498Z" fill="currentColor"></path>
                                                    </svg>}
                                            </div>
                                            <div className='leading-5'>
                                                <h1 className='font-[500] text-[19px]'>{item.message}</h1>
                                                <p className='font-[500] text-[16px] text-gray-600'>{item.status}</p>
                                            </div>
                                        </div>
                                        <span className={`font-[600] text-[18px] ${item.status === "Credit" ? "text-green-500" : "text-[red]"}`}>{item.status === "Debit" && "-"}{Currency + item.amt}</span>
                                    </div>
                                })
                                : <div className="h-[300px] flex items-center justify-center">
                                    <h1 className="font-bold text-[18px] text-gray-500">{t("No any transaction history !!")}</h1>
                                </div>
                            }
                        </div>
                    </div>
                </div>}

            {showPayBox && <div onClick={() => !paymentloading && setShowPayBox(false)} className="model items-end">
                <div onClick={(e) => e.stopPropagation()} className="bg-white w-[450px] rounded-t-[10px]">
                    <Payment totalpay={""} BookingData={""} isshow={"2"} PageIndex={"1"} />
                </div>
            </div>}

        </div>
    )
}

export default Wallet
/* jshint ignore:end */